import { Col, Row, Button, Modal, message } from "antd";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import Title from "../UI/Title/Title";
import { useMutation } from "react-query";
import { closeSession, pauseSession } from "../../api/sessions";
import { Dispatch, SetStateAction, useState } from "react";

type openpos = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSessionEnded: Dispatch<SetStateAction<boolean>>;
  sessionEnded: boolean;
  firstTime: boolean;
};
const EndSession = ({
  open,
  setOpen,
  setSessionEnded,
  sessionEnded,
  firstTime,
}: openpos) => {
  const [t] = useTranslation("common");
  const navigate = useNavigate();

  const sessionId = localStorage.getItem("sessionId");
  const currentDate = new Date();
  const year = String(currentDate.getFullYear());
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const hours = String(currentDate.getHours()).padStart(2, "0");
  const minutes = String(currentDate.getMinutes()).padStart(2, "0");
  const seconds = String(currentDate.getSeconds()).padStart(2, "0");
  const formattedDate = `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;

  const { mutateAsync: endSessionMutation } = useMutation(
    "endSession",
    async () => {
      const closeDate = formattedDate;
      await closeSession(Number(sessionId), { closeDate }); // Include closeDate in the request body
    }
  );
  const { mutateAsync: pauseSessionMutation } = useMutation(
    "pauseSession",
    () => pauseSession(Number(sessionId), true)
  );
  const { pathname } = useLocation();
  const [, setError] = useState("");

  const onError = (error: any, context?: unknown) => {
    if (setError) {
      setError(error.response.data.message);
      message.error({
        content: error.response.data.message,
        duration: 5,
        onClick: () => {
          message.destroy();
        },
      });
    }
  };
  const tillId = localStorage.getItem("tillId");
  const handleclick = (from: string) => {
    if (pathname !== `/initial/${tillId}`) {
      endSessionMutation()
        .then(() => {
          message.success("Session ended!");
          if (from === "logout") navigate("/logout");
          else if (from === "initial") navigate(`/initial/${tillId}`);
          setOpen(false);
        })
        .catch((error) => {
          onError(error);
        });
    } else {
      navigate("/logout");
    }
  };
  const handlePause = () => {
    pauseSessionMutation()
      .then(() => {
        message.success("Session paused!");
        navigate("/logout");
      })
      .catch(() => {
        message.error("Could not end session!");
      });
  };
  return (
    <>
      <Modal
        maskClosable={false}
        open={open}
        width={350}
        centered
        onCancel={() => setOpen(false)}
        closable={false}
        footer={null}
      >
        <Row>
          <Col span={23}>
            <Title title={`${t("session")}: ${sessionId}`} />
          </Col>
          <Col offset={2} span={24}>
            <Button
              style={{
                height: "60px",
                border: "1px solid #1677FF",
                background: sessionEnded || firstTime ? "#AAAAAA" : "#1677FF",
                color: "#FFFFFF",
                width: "250px",
                fontSize: "24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={() => {
                handlePause();
              }}
              disabled={sessionEnded || firstTime}
            >
              {t("pause-session")}
            </Button>
            <Button
              style={{
                height: "60px",
                background: "#FF0000",
                width: "250px",
                marginTop: "15px",
                color: "white",
                fontSize: "24px",
                borderRadius: "5px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={() => {
                handleclick("initial");
              }}
              disabled={sessionEnded || firstTime}
            >
              {t("end-session")}
            </Button>
            <Button
              style={{
                height: "60px",
                marginTop: "15px",
                border: "1px solid #1677FF",
                color: "#1677FF",
                width: "250px",
                fontSize: "24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={() => {
                setOpen(false);
              }}
            >
              {t("cancel")}
            </Button>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default EndSession;
